import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as func from "../../common/manipurCommon/FunctionCalls";
import * as api from "../../common/manipurCommon/API";
import Utils from "../../common/manipurCommon/Utils";
import { DataTable } from "primereact/datatable";
import Select from "react-select";
import { Column } from "primereact/column";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

interface TreatmentDetails {
    athltId: any;
    injId: any;
}

const Treatment: React.FC<TreatmentDetails> = ({ athltId, injId }) => {

    const [centerId, setCenterId] = useState("");
    const [athleteId, setAthleteId] = useState("");
    const [injuryId, setInjuryId] = useState("");
    const [treatmentId, setTreatmentId] = useState("");
    const [dateofPlanCreation, setDateOfPlanCreation] = useState("");
    const [shortTermGoals, setShortTermGoals] = useState("");
    const [longTermGoals, setLongTermGoals] = useState("");
    const [planofAction, setPlanofAction] = useState("");
    const [additionalRemarks, setAdditionalRemarks] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [centerList, setCenterList] = useState<any[]>([]);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [injuryList, setInjuryList] = useState<any[]>([]);
    const [treatmentList, setTreatmentList] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        async function fetchCenters() {
            setIsLoading(true);
            // const centersResponse = await func.listGeoCenters();
            // setCenterList(Array.isArray(centersResponse) ? centersResponse : [])
            const response = await func.listActiveAthletes();
            setAthleteList(Array.isArray(response) ? response : [])
            const treatmentResponse = await func.listInjuryTreatment(athltId);
            setTreatmentList(Array.isArray(treatmentResponse) ? treatmentResponse : []);
            setShowTable(true)
            setIsLoading(false);
        }
        fetchCenters();
    }, [])

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editInjuryTreatment(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const injId = rowData.treatmentPlanId;
        return (
            <Link to="#" onClick={() => deleteInjuryTreatment(injId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const dateRender = (rowData) => {
        return <span>{formatDate(rowData.dateofPlanCreation)}</span>
    };

    const injDateRender = (rowData) => {
        return <span>{formatDate(rowData.dateOfInjury)}</span>
    };

    const athleteRender = (rowData) => {
        return <span>{rowData.athleteName}</span>
    };

    const shortTermRender = (rowData) => {
        return <span>{rowData.shortTermGoals}</span>
    };

    const longTermRender = (rowData) => {
        return <span>{rowData.longTermGoals}</span>
    };

    const actionPlanRender = (rowData) => {
        return <span>{rowData.planofAction}</span>
    };

    const remarksRender = (rowData) => {
        return <span>{rowData.additionalRemarks}</span>
    };

    const injuryTreatmentStatusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>
    };

    const filteredData = treatmentList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    function newInjuryTreatment() {
        setOpenModal(true)
        setIsEdit(false)
        setCenterId("")
        setAthleteId("")
        setDateOfPlanCreation("")
        setShortTermGoals("")
        setLongTermGoals("")
        setPlanofAction("")
        setAdditionalRemarks("")
    }

    async function editInjuryTreatment(rowData) {
        // const injuryResponse = await func.listInjury(rowData.athleteId);
        // setInjuryList(Array.isArray(injuryResponse) ? injuryResponse : [])
        setTreatmentId(rowData.treatmentPlanId)
        setDateOfPlanCreation(rowData.dateofPlanCreation)
        setAthleteId(rowData.athleteId)
        setInjuryId(rowData.injuryId)
        setShortTermGoals(rowData.shortTermGoals);
        setLongTermGoals(rowData.longTermGoals);
        setPlanofAction(rowData.planofAction);
        setAdditionalRemarks(rowData.additionalRemarks);
        setIsEdit(true)
        setOpenModal(true)
    }

    function deleteInjuryTreatment(injuryId: string) {
        const delteInjury = api.InjuryTreatment + "/" + injuryId + "/0";
        fetch(delteInjury, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateInjuryTreatment();
            } else {
                const formData = new FormData();
                // formData.append("centerId", centerId);
                formData.append("athleteId", athltId);
                formData.append("injuryId", injId);
                formData.append("dateofPlanCreation", dateofPlanCreation);
                formData.append("shortTermGoals", shortTermGoals);
                formData.append("longTermGoals", longTermGoals);
                formData.append("planofAction", planofAction);
                formData.append("additionalRemarks", additionalRemarks);
                const createInjTreat = api.InjuryTreatment;
                fetch(createInjTreat, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
        }
    }

    function updateInjuryTreatment() {
        const formData = new FormData();
        // formData.append("centerId", centerId);
        formData.append("athleteId", athleteId);
        formData.append("injuryId", injuryId);
        formData.append("dateofPlanCreation", dateofPlanCreation);
        formData.append("shortTermGoals", shortTermGoals);
        formData.append("longTermGoals", longTermGoals);
        formData.append("planofAction", planofAction);
        formData.append("additionalRemarks", additionalRemarks);
        const createInjTreat = api.InjuryTreatment + "/" + treatmentId;
        fetch(createInjTreat, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    return (
        <>
            {
                isLoading && (
                    <div id="global-loader">
                        <div className="loader-img">
                            <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                        </div>
                    </div>
                )
            }
            <div className="content container" style={{ maxWidth: "1380px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Treatment</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newInjuryTreatment() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Injury Treatment">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="row">
                                    {/* <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Center</label>
                                            <Select
                                                value={centerList.find(cntr => cntr.geoCenterId === centerId) ? {
                                                    value: centerId,
                                                    label: centerList.find(cntr => cntr.geoCenterId === centerId).geoCenterName
                                                } : null}
                                                onChange={async (e) => {
                                                    setCenterId(e.value);
                                                    const response = await func.listCenterActiveAthletes(e.value);
                                                    setAthleteList(Array.isArray(response) ? response : [])
                                                }}
                                                // styles={customSelect}
                                                required
                                                placeholder="Select Center"
                                                options={centerList.map(cntr => ({
                                                    value: cntr.geoCenterId,
                                                    label: cntr.geoCenterName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div> */}
                                    {/* <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Athlete</label>
                                            <Select
                                                value={athleteList.find(athlt => athlt.userId === athleteId) ? {
                                                    value: athleteId,
                                                    label: athleteList.find(athlt => athlt.userId === athleteId).athleteName
                                                } : null}
                                                onChange={async (e) => {
                                                    setAthleteId(e.value);
                                                    const treatmentResponse = await func.listInjuryTreatment(e.value);
                                                    setTreatmentList(Array.isArray(treatmentResponse) ? treatmentResponse : []);
                                                    setShowTable(true)
                                                }}
                                                // styles={customSelect}
                                                required
                                                placeholder="Select Athlete"
                                                options={athleteList.map(athlt => ({
                                                    value: athlt.userId,
                                                    label: athlt.athleteName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div> */}
                                </div>
                                {showTable && (
                                    <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                        <label>
                                            <input
                                                type="text"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                style={{ height: "40px" }}
                                                placeholder="Search"
                                                className="form-control"
                                            />
                                        </label>
                                    </div>
                                )}
                            </div>
                            {showTable && (
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                pageLinkSize={3}
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    body={slNoRender}
                                                    header="Sl"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="athleteName"
                                                    header="Athlete"
                                                    body={athleteRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="dateofInjury"
                                                    header="Injury Date"
                                                    body={injDateRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="dateofPlanCreation"
                                                    header="Plan Date"
                                                    body={dateRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="shortTermGoals"
                                                    header="Short Term Goals"
                                                    body={shortTermRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="longTermGoals"
                                                    header="Long Term Goals"
                                                    body={longTermRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="planofAction"
                                                    header="Action Plan"
                                                    body={actionPlanRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="additionalRemarks"
                                                    header="Remarks"
                                                    body={remarksRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="status"
                                                    header="Status"
                                                    body={injuryTreatmentStatusRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                {currentPermissions.includes("edit") ?
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                    : null
                                                }
                                                {currentPermissions.includes("delete") ?
                                                    <Column
                                                        className="text-link"
                                                        body={deleteDetails}
                                                    ></Column>
                                                    : null
                                                }
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                centered
                size="xl">
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Treatment</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="row">
                            {!isEdit && (
                                <>
                                    {/* <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Center</label>
                                            <Select
                                                value={centerList.find(cntr => cntr.geoCenterId === centerId) ? {
                                                    value: centerId,
                                                    label: centerList.find(cntr => cntr.geoCenterId === centerId).geoCenterName
                                                } : null}
                                                onChange={async (e) => {
                                                    setCenterId(e.value);
                                                    const response = await func.listCenterActiveAthletes(e.value);
                                                    setAthleteList(Array.isArray(response) ? response : [])
                                                }}
                                                styles={customSelect}
                                                required
                                                placeholder="Select Center"
                                                options={centerList.map(cntr => ({
                                                    value: cntr.geoCenterId,
                                                    label: cntr.geoCenterName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div> */}
                                    {/* <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Athlete</label>
                                            <Select
                                                value={athleteList.find(athlt => athlt.userId === athleteId) ? {
                                                    value: athleteId,
                                                    label: athleteList.find(athlt => athlt.userId === athleteId).athleteName
                                                } : null}
                                                onChange={async (e) => {
                                                    setAthleteId(e.value);
                                                    const injuryResponse = await func.listInjury(e.value);
                                                    setInjuryList(Array.isArray(injuryResponse) ? injuryResponse : [])
                                                }}
                                                styles={customSelect}
                                                required
                                                placeholder="Select Athlete"
                                                options={athleteList.map(athlt => ({
                                                    value: athlt.userId,
                                                    label: athlt.athleteName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div> */}
                                </>
                            )}
                            {/* <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Injury</label>
                                    <Select
                                        value={injuryList.find(inj => inj.injuryId === injuryId) ? {
                                            value: injuryId,
                                            label: formatDate(injuryList.find(inj => inj.injuryId === injuryId).dateOfInjury)
                                        } : null}
                                        onChange={async (e) => {
                                            setInjuryId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        isDisabled={isEdit}
                                        placeholder="Select Injury"
                                        options={injuryList.map(inj => ({
                                            value: inj.injuryId,
                                            label: formatDate(inj.dateOfInjury)
                                        }))}>
                                    </Select>
                                </div>
                            </div> */}
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Date Of Plan Creation</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        required
                                        name="dateofPlanCreation"
                                        value={dateofPlanCreation}
                                        onChange={(e) => { setDateOfPlanCreation(e.target.value) }}
                                        placeholder="Enter Date of Plan Creation" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Short term Goals</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="shortTermGoals"
                                        value={shortTermGoals}
                                        onChange={(e) => { setShortTermGoals(e.target.value) }}
                                        placeholder="Enter Short Term Goals" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Long Term Goals</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="longTermGoals"
                                        value={longTermGoals}
                                        onChange={(e) => { setLongTermGoals(e.target.value) }}
                                        placeholder="Enter Provisional Diagnosis" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Plan of Action</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="planofAction"
                                        value={planofAction}
                                        onChange={(e) => { setPlanofAction(e.target.value) }}
                                        placeholder="Enter Plan of action" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Additional Remarks</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="additionalRemarks"
                                        value={additionalRemarks}
                                        onChange={(e) => { setAdditionalRemarks(e.target.value) }}
                                        placeholder="Enter Additional Remarks" />
                                </div>
                            </div>
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />{isEdit ? "Update " : "Save "}</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default Treatment;